import ApiService from '@/api/service';
import {
  LOGIN_URL
} from '@/api/constants';

export default {
  post(params) {
    return ApiService.post(LOGIN_URL, params);
  }
}